export const MAX_GRID_WIDTH = '1284px';

// this is incorporates the grid having 16px margins on left and right
export const MAX_MENU_WIDTH = '1254px';
